export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    month = "",
    year = "",
    debitAccountLabels = [],
    creditAccountLabels = [],
    rows = [],
    totals = {},
    recordedToLedgerDay = "",
    recordedToLedgerMonth = "",
    recordedToLedgerYear = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const rowHtml = rows.map((r) => `
    <tr>
      <td class="border text-center">${r.index || ""}</td>
      <td class="border px-1">${r.description || ""}</td>
      <td class="border text-right px-1">${fmt(r.openingDebit)}</td>
      <td class="border text-right px-1">${fmt(r.openingCredit)}</td>
      ${(r.debitValues || []).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
      <td class="border text-right px-1 font-bold bg-light">${fmt(r.totalDebit)}</td>
      ${(r.creditValues || []).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
      <td class="border text-right px-1 font-bold bg-light">${fmt(r.totalCredit)}</td>
      <td class="border text-right px-1 font-bold bg-light">${fmt(r.closingDebit)}</td>
      <td class="border text-right px-1 font-bold bg-light">${fmt(r.closingCredit)}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 11px; color: black; line-height: 1.3;">
      <table width="100%">
        <tr>
          <td width="50%" valign="top">
            <div class="font-bold">Đơn vị: <span class="dotted-line">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span class="dotted-line">${address}</span></div>
          </td>
          <td width="50%" align="center">
            <div class="font-bold">Mẫu số S04a10-DN</div>
            <div style="font-style: italic; font-size: 10px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 10px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 14px;">NHẬT KÝ CHỨNG TỪ SỐ 10</h2>
        <div style="font-size: 11px; font-style: italic;">Ghi Có Tài khoản 121, 128, 136, 138, 141, 171, 221, 222, 228, 229, 243, 244, 333, 336, 337, 338, 344, 347, 353, 411, 412, 413, 414, 418, 419, 421</div>
        <div style="margin-top: 5px; font-weight: bold;">
          Tháng ${month} năm ${year}
        </div>
      </div>

      <table width="100%" style="border-collapse: collapse; table-layout: fixed;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="30">Số TT</th>
            <th class="border" rowspan="2" width="180">Diễn giải</th>
            <th class="border" colspan="2">Số dư đầu tháng</th>
            <th class="border" colspan="5">Ghi Nợ Tài khoản..., ghi Có các tài khoản</th>
            <th class="border" colspan="5">Ghi Có Tài khoản..., ghi Nợ các tài khoản</th>
            <th class="border" colspan="2">Số dư cuối tháng</th>
          </tr>
          <tr>
            <th class="border" width="70">Nợ</th>
            <th class="border" width="70">Có</th>
            ${debitAccountLabels.map(l => `<th class="border" width="70">${l || "..."}</th>`).join("")}
            <th class="border" width="75">Cộng Nợ TK</th>
            ${creditAccountLabels.map(l => `<th class="border" width="70">${l || "..."}</th>`).join("")}
            <th class="border" width="75">Cộng Có TK</th>
            <th class="border" width="70">Nợ</th>
            <th class="border" width="70">Có</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            ${[...Array(16)].map((_, i) => `<th class="border">${i+1}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${rowHtml}
          <tr class="font-bold bg-light">
            <td class="border text-center" colspan="2">Cộng</td>
            <td class="border text-right px-1">${fmt(totals.openingDebit)}</td>
            <td class="border text-right px-1">${fmt(totals.openingCredit)}</td>
            ${(totals.debitValues || []).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
            <td class="border text-right px-1">${fmt(totals.totalDebit)}</td>
            ${(totals.creditValues || []).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
            <td class="border text-right px-1">${fmt(totals.totalCredit)}</td>
            <td class="border text-right px-1">${fmt(totals.closingDebit)}</td>
            <td class="border text-right px-1">${fmt(totals.closingCredit)}</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 10px;">
        Đã ghi Sổ Cái ngày <span class="font-bold">${recordedToLedgerDay}</span> tháng <span class="font-bold">${recordedToLedgerMonth}</span> năm <span class="font-bold">${recordedToLedgerYear}</span>
      </div>

      <table width="100%" style="margin-top: 20px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 40px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 40px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 11px; margin-bottom: 3px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 40px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 3px; }
        .bg-light { background-color: #f9f9f9; }
        .dotted-line { border-bottom: 1px dotted black; }
        @media print {
            @page { size: A4 landscape; margin: 0.8cm; }
        }
      </style>
    </div>
  `;
};
